import { IFinancialAccount } from '../../store/payments/payments-interfaces-helper';

export enum FINANCIAL_ACCOUNT_FORM_FIELD {
  ACCOUNT_TYPE = 'accountType',
  ACCOUNT_NUMBER = 'accountNumber',
  ROUTING_NUMBER = 'routingNumber',
  BANK_NAME = 'bankName',
}

export enum FINANCIAL_ACCOUNT_FORM_FIELD_NAMES {
  ACCOUNT_TYPE = 'NEW_APPLICATION.LABEL.DDA_TYPE',
  ACCOUNT_NUMBER = 'NEW_APPLICATION.LABEL.ACCOUNT_NUMBER',
  ROUTING_NUMBER = 'NEW_APPLICATION.LABEL.ROUTING_NUMBER',
  BANK_NAME = 'NEW_APPLICATION.LABEL.BANK_NAME',
}

export type FinancialAccountFieldsTypes = {
  [FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_TYPE]: string;
  [FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_NUMBER]: string;
  [FINANCIAL_ACCOUNT_FORM_FIELD.ROUTING_NUMBER]: string;
  [FINANCIAL_ACCOUNT_FORM_FIELD.BANK_NAME]: string;
}

export type FinancialAccountFieldsReturnTypes = {
  accountType: string;
  accountNumber: string | null;
  routingNumber: string | null;
  bankName: string;
//   relatedEntityType?: string;
//   relatedEntityId?: string;
}

export const financialAccountInitialValues: FinancialAccountFieldsTypes = {
  [FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_TYPE]: '',
  [FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_NUMBER]: '',
  [FINANCIAL_ACCOUNT_FORM_FIELD.ROUTING_NUMBER]: '',
  [FINANCIAL_ACCOUNT_FORM_FIELD.BANK_NAME]: '',
};

export const getFormattedFinancialAccountFormFields = (formikValues): FinancialAccountFieldsReturnTypes => ({
  accountType: formikValues?.[FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_TYPE] ? formikValues?.[FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_TYPE] : '',
  accountNumber: formikValues?.[FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_NUMBER],
  routingNumber: formikValues?.[FINANCIAL_ACCOUNT_FORM_FIELD.ROUTING_NUMBER],
  bankName: formikValues?.[FINANCIAL_ACCOUNT_FORM_FIELD.BANK_NAME],
  // relatedEntityType: 'Partner'
});

export const convertFinancialAccountFieldsToInitial = (data: IFinancialAccount): FinancialAccountFieldsTypes => ({
  [FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_TYPE]: data?.accountType ? data?.accountType : '',
  [FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_NUMBER]: data?.accountNumber ? data?.accountNumber : '',
  [FINANCIAL_ACCOUNT_FORM_FIELD.ROUTING_NUMBER]: data?.routingNumber ? data?.routingNumber : '',
  [FINANCIAL_ACCOUNT_FORM_FIELD.BANK_NAME]: data?.bankName ? data?.bankName : '',
});

export const getFormattedFinancialAccountData = (data): FinancialAccountFieldsReturnTypes => ({
  accountType: data?.accountType,
  accountNumber: data?.accountNumber,
  routingNumber: data?.routingNumber,
  bankName: data?.bankName,
  // relatedEntityType: 'Partner'
});
